export enum AnnouncementType {
  Maintenance = 'maintenance',
  News = 'news',
}

export interface Announcement {
  id: string
  type: AnnouncementType
  title: string
  content: string
  readMore?: string
}
